export const DASHBOADTAB = "Dashboard";
export const GROUPSTAB = "GROUPS";
export const USERSTAB = "USERS";
